import Vue from 'vue'

export const state = {
  showedRoutes: {},
  formValues: {},
  vehiclesRoutes: [],
  showResponse: {},
  unservedShowResponse: {},
}

export const mutations = {
  INIT_SHOWEDROUTES(state, payload) {
    state.showedRoutes = payload
  },

  SET_SHOWEDROUTES(state, payload) {
    Vue.set(state.showedRoutes, payload.key, payload.value)
  },

  TOGGLE_ALL_SHOWEDROUTES(state, payload) {
    Object.keys(state.showedRoutes).forEach((key) => {
      Vue.set(state.showedRoutes, key, payload)
    })
  },

  RESET_SHOWEDROUTES(state) {
    state.showedRoutes = {}
  },

  SET_VEHICLES_ROUTES(state, payload) {
    state.vehiclesRoutes = payload
  },

  RESET_VEHICLES_ROUTES(state) {
    state.vehiclesRoutes = []
  },

  SET_SHOW_RESPONSE(state, payload) {
    state.showResponse = payload
  },

  RESET_SHOW_RESPONSE(state) {
    state.showResponse = {}
  },

  SET_UNSERVED_SHOW_RESPONSE(state, payload) {
    state.unservedShowResponse = payload
  },
}

export const actions = {
  initShowedRoutes({ commit }, payload) {
    commit('INIT_SHOWEDROUTES', payload)
  },

  setShowedRoutes({ commit }, payload) {
    commit('SET_SHOWEDROUTES', payload)
  },

  toggleAllShowedRoutes({ commit }, payload) {
    commit('TOGGLE_ALL_SHOWEDROUTES', payload)
  },

  resetShowedRoutes({ commit }) {
    commit('RESET_SHOWEDROUTES')
  },

  setVehiclesRoutes({ commit }, payload) {
    commit('SET_VEHICLES_ROUTES', payload)
  },

  resetVehiclesRoutes({ commit }) {
    commit('RESET_VEHICLES_ROUTES')
  },

  setShowResponse({ commit }, payload) {
    commit('SET_SHOW_RESPONSE', payload)
  },

  resetShowResponse({ commit }) {
    commit('RESET_SHOW_RESPONSE')
  },

  setUnservedShowResponse({ commit }, payload) {
    commit('SET_UNSERVED_SHOW_RESPONSE', payload)
  },
}

export const getters = {
  getVehiclesRoutes: (state) => state.vehiclesRoutes,
  getVehicleRouteById: (state) => (id) => {
    return state.vehiclesRoutes.find((vehicle) => vehicle.id === id)
  },
  getShowResponse: (state) => state.showResponse,
}
